export const affordabilityCalculatorInitialValues = {
  incomeValue: 75000,
  carPaymentValue: 250,
  studentPaymentValue: 75,
  cardPaymentValue: 50,
  otherPaymentValue: 0,
  debtToIncome: 0.3,
  downPaymentPercent: 0.1,
  interestRate: 0.05,
  mortgageTerm: 30,
  propertyTaxRate: 0.013,
  mortgageInsurance: 0.0055,
};

export const affordabilityManuallyChangedFields = {
  carPaymentValue: false,
  studentPaymentValue: false,
  cardPaymentValue: false,
};

export const mobnthlyPaymentCalculatorInitialValues = {
  mortgageValue: 250000,
  interestRate: 0.05,
  mortgageTerm: 30,
};



// WEBPACK FOOTER //
// ./src/utils/calculatorsHelper.js